import * as React from 'react';
import { connect } from 'react-redux';
import { StepContainer, StepLayouts } from '@ane/ui-components/lib/components/StepContainer';
import { CreateStepTitle } from '../CreateWizard/CreateSteps';
import { DetailsListWithCommandBar } from '@ane/ui-components/lib/components/DetailsList/DetailsListWithCommandBar';
import { SelectionMode, Selection } from '@ane/ui-components';
import { FormHeading } from '@ane/ui-components/lib/components/FormHeading';
import { FormSection } from '@ane/ui-components/lib/components/FormSection';
import DataPathField from './AvailabilityStreamFieldConfig';
const mapStateToProps = (state) => {
    return {};
};
const mapDispatchToProps = {};
export class AvailabilityStreamInfoComponent extends React.Component {
    constructor(props) {
        super(props);
        this._selection = new Selection();
    }
    render() {
        var _a, _b, _c, _d;
        const items = [];
        items.push({
            key: 'add-datasource-availability',
            ariaLabel: 'Add dependency file',
            disabled: !!this.props.isReadOnly,
            iconProps: {
                iconName: 'Add',
            },
            name: 'Add dependency file',
            onClick: () => {
                var _a, _b, _c, _d, _e, _f;
                let streamList = [
                    ...(((_b = (_a = this.props.formikProps) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.streamList) ? (_d = (_c = this.props.formikProps) === null || _c === void 0 ? void 0 : _c.values) === null || _d === void 0 ? void 0 : _d.streamList : []),
                    {
                        DataPath: '',
                        VC: '',
                        Cluster: '',
                        delete: null,
                        required: {
                            DataPath: 'Required',
                            VC: '',
                            Cluster: '',
                        },
                    },
                ];
                (_f = (_e = this.props.formikProps) === null || _e === void 0 ? void 0 : _e.setFieldValue) === null || _f === void 0 ? void 0 : _f.call(_e, 'streamList', streamList, true);
            },
        });
        items.push({
            key: 'delete-datasource-availability',
            ariaLabel: 'Delete availability',
            disabled: !!this.props.isReadOnly,
            iconProps: {
                iconName: 'Delete',
            },
            name: 'Delete',
            onClick: () => {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                const index = this._selection.getSelectedIndices();
                if (index.length <= 0)
                    return;
                let streamList = [];
                if ((_b = (_a = this.props.formikProps) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.streamList) {
                    streamList = [
                        ...(_d = (_c = this.props.formikProps) === null || _c === void 0 ? void 0 : _c.values) === null || _d === void 0 ? void 0 : _d.streamList.slice(0, index[0]),
                        ...(_f = (_e = this.props.formikProps) === null || _e === void 0 ? void 0 : _e.values) === null || _f === void 0 ? void 0 : _f.streamList.slice(index[0] + 1),
                    ];
                }
                (_h = (_g = this.props.formikProps) === null || _g === void 0 ? void 0 : _g.setFieldValue) === null || _h === void 0 ? void 0 : _h.call(_g, 'streamList', streamList, true);
            },
        });
        return (React.createElement(StepContainer, { className: "create-availabilitystream-info-tab", layout: StepLayouts.fullWidth },
            !this.props.isUpdateDataSource && (React.createElement(FormHeading, { pageTitle: CreateStepTitle.Availability }, "This is where you optionally add any dependency files for your data source.")),
            React.createElement(FormSection, null,
                React.createElement(DetailsListWithCommandBar, { commandBarProps: { ariaLabel: 'action items for data source dependency file list', items: items }, detailsListProps: {
                        selection: this._selection,
                        selectionMode: SelectionMode.single,
                        items: ((_b = (_a = this.props.formikProps) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.streamList) ? (_d = (_c = this.props.formikProps) === null || _c === void 0 ? void 0 : _c.values) === null || _d === void 0 ? void 0 : _d.streamList : [],
                        columns: [
                            {
                                key: 'DataPath',
                                name: 'Data path',
                                minWidth: 280,
                                fieldName: 'DataPath',
                                data: 'string',
                                onRender: (item, index, column) => {
                                    return React.createElement(DataPathField, { formikProps: this.props.formikProps, index: index !== null && index !== void 0 ? index : 0 });
                                },
                            },
                        ],
                        defaultSortColumn: 'DataPath',
                        ariaLabelForGrid: 'availability stream info',
                    } }))));
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(AvailabilityStreamInfoComponent);

//# sourceMappingURL=AvailabilityStreamInfoComponent.js.map
